<template>
  <main class="referral-guide-page">
    <AppNavBar
      :title="t('invite.referralStepsTitle')"
      :border="false"
      :fixed="false"
      :placeholder="false"
      :auto-back="false"
      @click-left="router.replace('/home/index')"
    />
    <div class="referral-guide-page__body">
      <iframe
        class="referral-guide-page__frame"
        :src="guideUrl"
        :title="t('invite.referralStepsTitle')"
      />
    </div>
  </main>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import AppNavBar from "@/components/AppNavBar.vue";

const { t, locale } = useI18n();
const router = useRouter();

const guideLocaleMap = {
  "zh-CN": "zh_CN",
  "zh-HK": "zh_HK",
  "en-US": "en_US",
  "vi-VN": "vi_VN",
  "id-ID": "id_ID",
  "ms-MY": "ms_MY",
};

const guideUrl = computed(() => {
  const guideLocale = guideLocaleMap[locale.value] || "zh_CN";
  return `https://winpay.com/ReferralGuide/referral-guide_${guideLocale}.html`;
});
</script>

<style scoped>
.referral-guide-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: var(--app-viewport-height);
  overflow: hidden;
  background: #fff;
}

.referral-guide-page__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background: #fff;
}

.referral-guide-page > :deep(.van-nav-bar) {
  flex: 0 0 auto;
  width: 100%;
}

.referral-guide-page__frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}
</style>
